<template>
  <div class="Form-field">
    <label
      :for="id"
      class="Form-label"
    >
      {{ label }}
      <span
        v-if="required"
        class="Form-required"
      >
        *
      </span>
    </label>
    <div
      :class="['Form-inputBox', icon, {'Has-icon':hasIcon, 'Form--iconTick': !error.invalid && error.dirty || !error.invalid && activeValidation}]"
    >
      <select
        :id="id"
        :placeholder="placeholder"
        :class="['Form-select', {'form-valid': !error.invalid && error.dirty || !error.invalid && activeValidation}]"
        :name="name"
        :required="required"
        :disabled="disabled"
        :value="modelData"
        v-bind="$attrs"
        @blur="isBlurred = true"
        @change="handler"
        v-on="$listeners"
      >
        <option
          v-if="placeholder"
          value=""
          hidden
        >
          {{ placeholder }}
        </option>
        <option
          v-for="item in items"
          :key="optionValue(item)"
          :value="optionValue(item)"
        >
          {{ optionLabel(item) }}
        </option>
      </select>
    </div>
    <error-messages
      :errors="error.errors"
      :is-blurred="isBlurred"
      :manual-validate="manualValidate"
    />
    <hint-message
      :hint="hint"
    />
  </div>
</template>

<script>
/* eslint no-underscore-dangle: 0 */
import formInputMixin from '@/mixins/form-input-mixin';

export default {
  name: 'RmpSelect',

  mixins: [formInputMixin],

  model: {
    prop: 'modelData',
    event: 'rmp:change',
  },

  props: {
    id: {
      type: String,
      default() {
        return `select-id-${this._uid}`;
      },
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    manualValidate: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    modelData: {
      default: null,
      type: [String, Number],
    },
    // Only required if passing an array of objects into items
    optionLabelKey: {
      type: String,
      default: null,
    },
    // Only required if passing an array of objects into items
    optionValueKey: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      default: null,
    },
    activeValidation: {
      type: Boolean,
      default: false,
    },
    hint: {
      default: null,
      type: Object,
    },
    error: {
      default() {
        return {};
      },
      type: Object,
    },
    label: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isBlurred: false,
    };
  },

  methods: {
    handler(event) {
      this.$emit('rmp:change', event.target.value);
    },
    optionValue(item) {
      return this.optionValueKey ? item[this.optionValueKey] : item;
    },
    optionLabel(item) {
      return this.optionLabelKey ? item[this.optionLabelKey] : item;
    },
  },

};
</script>
